import { IEmployee } from './../../settings/types/employee'
import { IPagination } from '../../../types/pagination'
import { IProjectCurrentDirectCosts, IProjectCurrentTasks } from '../../project/types/project'
import { IProjectActivity } from '../../project/types/projectActivity'
import { ITimeTracking, ITimeTrackingInvolvedTaskFilter, ITimeTrackingChart, ITimeTrackingDonutChart, ITimeTrackingInvolvedTasks } from '../types/timeTracking'
import { combineReducers } from 'redux'
import {
  activeTab, currentTasks, currentTasksPagination, paginatedCurrentTasksActivePage,
  timeTrackingEntries, timeTrackingEntry, timeTrackingInvolvedTasks, currentTasksStatusFilter,
  filterTimeTrackingInvolvedTasks, timeTrackingChartEntry, timeTrackingDonutChartEntry, employee, currentDirectCostsPagination, currentDirectCosts
} from './timeTrackingReducer'
import { IDirectCost } from '../../project/types/directAndPassTroughCosts'

export interface TimeTrackingState {
  activeTab: string
  timeTrackingEntries: ITimeTracking[]
  timeTrackingEntry: ITimeTracking
  timeTrackingInvolvedTasks: ITimeTrackingInvolvedTasks[]
  filterTimeTrackingInvolvedTasks: ITimeTrackingInvolvedTaskFilter
  timeTrackingChartEntry: ITimeTrackingChart
  timeTrackingDonutChartEntry: ITimeTrackingDonutChart
  currentTasks: IProjectCurrentTasks
  currentTasksPagination: IPagination<IProjectActivity[]>
  paginatedCurrentTasksActivePage: number
  currentTasksStatusFilter: string
  employee: IEmployee | null
  currentDirectCosts: IProjectCurrentDirectCosts
  currentDirectCostsPagination: IPagination<IDirectCost[]>
}

const timeTrackingApp = combineReducers<TimeTrackingState>({
  activeTab,
  timeTrackingEntries,
  timeTrackingEntry,
  timeTrackingInvolvedTasks,
  filterTimeTrackingInvolvedTasks,
  timeTrackingChartEntry,
  timeTrackingDonutChartEntry,
  currentTasks,
  currentTasksPagination,
  paginatedCurrentTasksActivePage,
  currentTasksStatusFilter,
  employee,
  currentDirectCostsPagination,
  currentDirectCosts
})

export default timeTrackingApp
